import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { emailInitials, nameInitials } from '@prophecy/utils/string';
import React, { useState } from 'react';
import isEmail from 'validator/lib/isEmail';
import { PlusIcon, UserAIcon } from '../Icons';
import { theme } from '../theme';
import { renderWithTooltip, Tooltip } from '../Tooltip';
import { LabelWithHint } from '../Typography/LabelWithHint';
import { AvatarIndicator } from './AvatarIndicator';
import { Root, Text, Image, StyledAddButton, StyledAvatar, StyledAvatarImageWrapper, StyledDefaultIcon } from './styled';
export const Avatar = ({ text, icon, src, hint, tooltip, size, indicatorProps, className, ...rest })=>{
    const getAvatarContent = ()=>{
        if (src) return /*#__PURE__*/ _jsx(ImageAvatar, {
            src: src,
            size: size,
            ...rest
        });
        if (text) return /*#__PURE__*/ _jsx(TextAvatar, {
            text: text,
            size: size,
            ...rest
        });
        if (icon) return /*#__PURE__*/ _jsx(IconAvatar, {
            icon: icon,
            size: size,
            ...rest
        });
        return null;
    };
    const avatarContent = getAvatarContent();
    if (!avatarContent) return null;
    let avatarUI = /*#__PURE__*/ _jsxs(StyledAvatar, {
        $variant: indicatorProps?.variant,
        className: className,
        children: [
            avatarContent,
            indicatorProps && /*#__PURE__*/ _jsx(AvatarIndicator, {
                size: size,
                variant: indicatorProps?.variant,
                status: indicatorProps?.status,
                icon: indicatorProps?.icon
            })
        ]
    });
    // Apply tooltip
    if (tooltip) {
        avatarUI = /*#__PURE__*/ _jsx(_Fragment, {
            children: renderWithTooltip(/*#__PURE__*/ _jsx("div", {
                children: avatarUI
            }), tooltip)
        });
    }
    // Apply hint
    if (hint) {
        avatarUI = /*#__PURE__*/ _jsx(LabelWithHint, {
            hint: hint,
            children: /*#__PURE__*/ _jsx("div", {
                children: avatarUI
            })
        });
    }
    return avatarUI;
};
function TextAvatar({ size, text, ...rest }) {
    const initial = isEmail(text) ? emailInitials(text) : nameInitials(text);
    return /*#__PURE__*/ _jsx(Root, {
        size: size,
        ...rest,
        children: /*#__PURE__*/ _jsx(Text, {
            size: size,
            children: initial
        })
    });
}
function IconAvatar({ size, icon, ...rest }) {
    return /*#__PURE__*/ _jsx(Root, {
        size: size,
        ...rest,
        children: /*#__PURE__*/ _jsx("span", {
            children: icon
        })
    });
}
export function ImageAvatar({ size, src, ...rest }) {
    const [error, setError] = useState(false);
    return /*#__PURE__*/ _jsxs(StyledAvatarImageWrapper, {
        $size: size,
        ...rest,
        children: [
            /*#__PURE__*/ _jsx(Image, {
                src: src,
                $visible: !error,
                onLoad: ()=>setError(false),
                onError: ()=>setError(true)
            }),
            error && /*#__PURE__*/ _jsx(StyledDefaultIcon, {
                $size: size,
                children: /*#__PURE__*/ _jsx(UserAIcon, {
                    type: "default",
                    color: theme.colors.gray500
                })
            })
        ]
    });
}
export function AvatarAddButton({ size, disabled, tooltipProps, ...rest }) {
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: "Add User",
        placement: "top",
        disabled: disabled,
        ...tooltipProps,
        children: /*#__PURE__*/ _jsx(StyledAddButton, {
            variant: "secondaryGray",
            size: size,
            $disabled: disabled,
            disablePointerFocus: true,
            ...rest,
            "data-test-id": "avatar-add-button",
            children: /*#__PURE__*/ _jsx(PlusIcon, {
                type: "default"
            })
        })
    });
}
